<script>
    /**
     * 页面头部
     */
    import FixedDropDown from './FixedDropDown';
    import BreadCrumb from './BreadCrumb';
    import BreadCrumbItem from './BreadCrumbItem';
    import DiyDropDown from './DiyDropDown';
    import NormalCascader from './NormalCascader';
    import IconSvg from './IconSvg';
    import '../../iconfont';

    export default {
        name: 'common-header',
        props: {
            withSvg: {
                type: Boolean,
                require: false,
                default: true
            },
            svgIconClass: {
                type: String,
                required: false,
                default: 'icon-jiyuehualogodefuben'
            },
            position: {
                type: String,
                require: false,
                default: 'fixed'
            },
            withRight: {
                type: Boolean,
                require: false,
                default: true
            },
            showSites: {
                type: Boolean,
                require: false,
                default: true
            },
            showMessageCenter: {
                type: Boolean,
                require: false,
                default: true
            },
            logoIcon: {
                type: String,
                require: false,
                default: '&#xe774;'
            },
            path: {
                type: Array,
                require: false,
                default: () => []
            },
            fixedDropDownOptionList: {
                type: Array,
                require: false,
                default: () => []
            },
            website: {
                type: Object,
                require: false,
                default: () => {}
            },
            user: {
                type: Object,
                require: false,
                default: () => {}
            },
            sites: {
                type: Array,
                require: false,
                default: () => []
            },
            msgNum: {
                type: Number,
                require: false,
                default: 0
            },
            // 0927 v1.27 去掉
            // isHasExpand: {
            //     type: Boolean,
            //     require: false,
            //     default: true
            // },
            userAppList: {
                type: Array,
                require: false,
                default: () => []
            },
            showGuide: {
                require: false,
                type: Boolean,
                default: true
            },
            hideAppList: {
                require: false,
                type: Boolean,
                default: false
            },
            notAppName: {
                require: false,
                type: Boolean,
                default: false
            },
            sourceApp: {
                require: false,
                type: String,
                default: ''
            },
            appConfig: {
                type: Object,
                require: false
            },
            innerGuideLink: {
                require: false,
                type: String,
                default: 'http://migratesite1.southcn.com/czzy'
            },
            enableAuthMessage: {
                required: false,
                type: Boolean,
                default: true
            },
            messageUrl: {
                required: false,
                type: String
            }
            //0927 v1.27 去掉
            // isExpand: {
            //     type: Boolean,
            //     require: false,
            //     default: false
            // }
        },
        data () {
            return {
                //0927 v1.27 去掉
                // innerExpand: false,
                mapText: {
                    yyyy: '运营应用',
                    glkh: '管理考核',
                    yxjk: '运行监控',
                    styy: '生态应用'
                }
            };
        },
        created () {},
        components: {
            IconSvg,
            DiyDropDown,
            FixedDropDown,
            BreadCrumbItem,
            BreadCrumb,
            NormalCascader
        },
        //0927 v1.27 去掉
        // watch: {
        //     isExpand (v) {
        //         this.innerExpand = v;
        //     }
        // },
        methods: {
            naviAppCenter (item) {
                this.$refs.diyDropDown.droped = false;
                window.open(item.link);
                this.$emit('clickApp', item);
            },
            naviMessage () {
                if (this.sourceApp && this.appConfig) {
                    return this.compShowMessageCenter
                        ? window.open(this.getRightUrl(this.appConfig.topbar_message_url))
                        : undefined;
                }
                this.$emit('clickMessage');
            },
            optClick ($e) {
                this.$emit($e);
            },
            getRightUrl ($e) {
                const hashIdx = $e.lastIndexOf('#');
                const queryIdx = $e.lastIndexOf('?');

                if ((hashIdx > -1 && queryIdx > hashIdx) || (hashIdx === -1 && queryIdx > -1)) {
                    $e = `${ $e }&source_app=${ this.sourceApp }`;
                } else {
                    $e = `${ $e }?source_app=${ this.sourceApp }`;
                }
                const {id, service_area_id} = this.website;
                return $e.replace('{$SID}', id).replace('{$AID}', service_area_id);
            },
            selectOpt ($e) {
                if ($e === '__inner_guide__') {
                    // return window.open('http://migratesite1.southcn.com/czzy');
                    return window.open(this.innerGuideLink);
                } else if (
                    this.sourceApp &&
                    ($e.startsWith('http://') || $e.startsWith('https://') || $e.startsWith('//') || $e[0] === '/')
                ) {
                    return window.open(this.getRightUrl($e));
                }
                this.$emit('selectFixDropDown', $e);
            },
            gotoUserCenter () {
                this.$emit('selectFixDropDown', this.fixedDropDownOptionList[0].value);
            },
            goIndex () {
                this.$emit('clickLogo');
            },
            selectSite (item) {
                this.$emit('selectSite', item);
            },
            handleClickBreadCrumbItem (item) {
                this.$emit('clickPath', item);
            },
            //0927 v1.27 去掉
            // goExpand () {
            //     if (!this.isHasExpand) {
            //         return;
            //     }
            //     this.innerExpand = !this.innerExpand;
            //     this.$emit('expand', this.innerExpand);
            // },
            scrollHandle () {
                if (this.position === 'absolute') {
                    return;
                }
                const st = document.documentElement.scrollLeft;
                this.$refs.header.style.left = `${ -st }px`;
            },
            handleAuthMessage () {
                //延迟5s，尽可能获取appurls
                setTimeout(() => {
                    const $iframe = document.createElement('iframe');
                    let mcUrl = '';
                    if (this.appConfig && this.appConfig.topbar_message_url) {
                        mcUrl = this.appConfig.topbar_message_url;
                    }
                    if (!mcUrl) {
                        if (this.$store && this.$store.state.appUrls && this.$store.state.appUrls.message_center_url) {
                            mcUrl = this.$store.state.appUrls.message_center_url;
                        } else {
                            mcUrl = this.messageUrl;
                        }
                    }
                    if (!mcUrl) {
                        return;
                    }
                    $iframe.src = `${ mcUrl }?vision=iframe`;
                    $iframe.style.display = 'none';
                    document.body.appendChild($iframe);
                    $iframe.onload = () => {
                        window.cloud_cancel_timer && window.cloud_cancel_timer();

                        const sources = Array.from(document.querySelectorAll('script')).filter(v =>
                            v.src.endsWith('uc/keepalive')
                        );
                        if (sources && sources.length) {
                            const $script = document.createElement('script');
                            $script.src = sources[0].src.replace('http://', '//').replace('https://', '//');
                            document.body.appendChild($script);
                        }
                    };
                }, 5000);
            }
        },
        computed: {
            compHeaderStyle () {
                const style = {position: this.position};
                if (this.sourceApp && this.appConfig) {
                    this.appConfig.topbar_style_font_color && (style.color = this.appConfig.topbar_style_font_color);
                    this.appConfig.topbar_style_text &&
                    this.appConfig.topbar_style_text.split('、').forEach(v => {
                        const [ key, value ] = v.split('|');
                        style[key] = value;
                    });
                    return style;
                }
                return style;
            },
            compTextStyle () {
                if (this.appConfig && this.appConfig.topbar_style_font_color) {
                    return {
                        color: this.appConfig.topbar_style_font_color
                    };
                }
                return {};
            },
            compFixedDropDownOptionList () {
                if (this.sourceApp && this.appConfig && this.appConfig.topbar_right_menus) {
                    return this.appConfig.topbar_right_menus
                        .split(',')
                        .map(v => {
                            v = v.split('|');
                            let [ icon, text, value, isButton, auths ] = v;
                            isButton = Number(isButton);
                            icon = icon === '0' ? '' : icon;

                            auths = this.$util.getAuthGroups(auths);
                            if (
                                !auths ||
                                auths.includes('all') ||
                                (this.user.group !== 3 && auths.includes('site_character') && !this.website.site_character) ||
                                auths.includes(this.user.group)
                            ) {
                                return {
                                    icon,
                                    text,
                                    value,
                                    isButton
                                };
                            }
                        })
                        .filter(v => v);
                }

                const opts = this.fixedDropDownOptionList;

                if (this.showGuide && opts.every(v => v.text !== '在线指南') && !this.sourceApp) {
                    opts.push({
                        text: '在线指南',
                        value: '__inner_guide__',
                        icon: '&#xe728'
                    });
                }
                return opts;
            },
            compUserAPPList () {
                const userAppList = this.userAppList;
                const map = {};
                userAppList.forEach(v => {
                    if (v.type !== 'yxjk' && v.type !== 'glkh' && v.type !== 'styy') {
                        v.type = 'yyyy';
                    }
                    map[v.type] = map[v.type] || [];
                    map[v.type].push(v);
                    map[v.type].sort((a, b) => a.sort - b.sort);
                });
                return map;
            },
            compWithSvg () {
                if (this.sourceApp && this.appConfig) {
                    return this.appConfig.pt_logo_type === 1;
                } else {
                    return this.withSvg;
                }
            },
            compSvgIconClass () {
                if (this.sourceApp && this.appConfig) {
                    return this.appConfig.pt_logo;
                } else {
                    return this.svgIconClass;
                }
            },
            compLogoIcon () {
                if (this.sourceApp && this.appConfig) {
                    return this.appConfig.pt_logo;
                } else {
                    return this.logoIcon;
                }
            },
            compTextMap () {
                if (this.sourceApp && this.appConfig) {
                    let obj = {}
                    ;(this.appConfig.topbar_app_group_textmap || '').split(',').forEach(v => {
                        const [ , value, text ] = v.split('|');
                        obj[value] = text;
                    });
                    return obj;
                } else {
                    return this.mapText;
                }
            },
            compShowMessageCenter () {
                if (this.sourceApp && this.appConfig) {
                    return this.appConfig.topbar_message_enable;
                } else {
                    return this.showMessageCenter;
                }
            }
        },
        beforeDestroy () {
            window.removeEventListener('scroll', this.scrollHandle);
        },
        mounted () {
            window.addEventListener('scroll', this.scrollHandle);
            if (this.enableAuthMessage && this.compShowMessageCenter) {
                this.handleAuthMessage();
            }
        }
    };
</script>

<template>
    <div class="common-header" :style="compHeaderStyle" ref="header">
        <div class="center">
            <div class="left-part" :style="compTextStyle">
                <!-- <div class="menu left">
                    <div class="lines"></div>
                </div> -->
                <div class="logo left" @click="goIndex" v-html="compLogoIcon" v-if="!compWithSvg"></div>
                <icon-svg class="logo logo-svg left" :icon-class="compSvgIconClass" v-else/>
                <bread-crumb :style="compTextStyle" :class="compWithSvg ? 'logo-text-svg' : ''"
                             separatorIcon="&#xe69f;">
                    <bread-crumb-item
                        v-for="(item, key) in path"
                        @click.native.capture.stop="handleClickBreadCrumbItem(item)"
                        :key="key"
                    >
                        {{ item.name }}
                    </bread-crumb-item>
                </bread-crumb>
                <slot name="nfcms-operate"></slot>
                <span
                    class="left-split left"
                    :style="compTextStyle"
                    v-if="notAppName || ($slots.default && $slots.default[0].text.trim())"
                >
                    |
                </span>
                <div class="app-name logo-text left" :style="compTextStyle">
                    <slot></slot>
                </div>
                <slot name="nfcms-sites"></slot>
            </div>
            <div class="right-part right" v-if="withRight" :style="compTextStyle">
                <div class="text-item left website" v-if="showSites">
                    <normal-cascader
                        :with-tool-tip="true"
                        :style="compTextStyle"
                        :withSearch="true"
                        class="site-select"
                        :options="sites"
                        @select="selectSite"
                        v-model="website.serviceValue"
                    ></normal-cascader>
                </div>
                <span class="left-split left in-right-part" v-if="showSites">|</span>
                <diy-drop-down
                    class="icon-item left"
                    :style="compTextStyle"
                    v-if="!hideAppList"
                    ref="diyDropDown"
                    :margin-right="2.6"
                    :height-opts="410"
                    position="fixed"
                    optCls="header-diy-opt-cls"
                    text="&#xe658;"
                >
                    <div class="option-list-wrap" v-if="userAppList.length">
                        <template v-for="(item, key) in compUserAPPList">
                            <div class="row x1 app-type-title" :key="key">
                                {{ compTextMap[key] }}
                            </div>
                            <div
                                class="app-item-with-image-sm"
                                v-for="(app, idx) in item"
                                :key="`${key}-${idx}`"
                                @click="naviAppCenter(app)"
                            >
                                <img :src="app.img" alt="app.group_name"/>
                                <p>{{ app.group_name }}</p>
                            </div>
                        </template>
                    </div>
                </diy-drop-down>
                <div
                    v-show="compShowMessageCenter"
                    :style="compTextStyle"
                    class="icon-item message-icon left"
                    :class="[msgNum > 0 ? 'message' : '']"
                    @click="naviMessage"
                >
                    &#xe657;
                </div>
                <fixed-drop-down
                    :style="compTextStyle"
                    class="right-part-name-opt"
                    :options="compFixedDropDownOptionList"
                    :text="user.name"
                    @select="selectOpt($event)"
                    @opt-click="optClick($event)"
                ></fixed-drop-down>
                <img class="avatar left" @click="gotoUserCenter" :src="user.img_url || user.avatarUrl || user.avatar"/>
            </div>
        </div>
    </div>
</template>
<style lang="less">
    .site-select {
        .normal-input {
            input {
                color: inherit;
                background-color: transparent;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }

    @media screen and (max-width: 1350px) {
        .site-select {
            .normal-input {
                max-width: 370px;
            }
        }
    }

    @media screen and (max-width: 1300px) {
        .site-select {
            .normal-input {
                max-width: 310px;
            }
        }
    }

    @media screen and (max-width: 1250px) {
        .site-select {
            .normal-input {
                max-width: 270px;
            }
        }
    }

    @media screen and (min-width: 1351px) {
        .site-select {
            .normal-input {
                max-width: unset;
            }
        }
    }
</style>
<style lang="less">
    @import '../../assets/less/widgets-var';

    .header-diy-opt-cls.option-list {
        box-sizing: border-box;
        height: 410px;
        width: 378px;

        .app-type-title {
            text-align: center;
            line-height: 50px;
            position: relative;
            font-size: 15px;
            color: @otherNormalTitleClr;

            &:after,
            &:before {
                content: '';
                position: absolute;
                height: 1px;
                width: 90px;
                background-color: @otherBorderClr;
                top: 50%;
            }

            &:after {
                left: 10px;
            }

            &:before {
                right: 10px;
            }
        }

        .option-list-wrap {
            overflow: hidden;
            padding: 20px 24px 0 24px;
            text-align: left;
            white-space: normal;
            background: #fff;
            margin: 0;
            min-height: 100px;
            box-sizing: border-box;
        }
    }

    .app-item-with-image-sm {
        box-sizing: border-box;
        width: 110px;
        height: 90px;
        float: left;
        text-align: center;
        padding: 10px 10px 0 10px;
        margin-bottom: 10px;
        cursor: pointer;
        .transition-on;

        &:hover {
            background-color: @otherBtnHoverClr;
        }

        img {
            width: 36px;
            height: 36px;
        }

        p {
            margin: 4px 0 0 0;
            text-align: center;
            font-size: 12px;
            color: #333;
        }
    }

    .icon-item.diy-drop-down {
        height: auto;
        line-height: normal;

        .selected {
            height: auto;
            line-height: normal;
            padding: 0;
            font-size: 20px;

            &:after,
            &:before {
                display: none;
            }
        }
    }

    .text-item {
        &.user-name {
            margin-top: 25px;
            margin-right: 15px;
        }

        &.website {
            margin-top: 20px;

            .drop-frame {
                color: @otherNormalTitleClr;

                input {
                    text-align: right;
                    border: none;
                    color: inherit;
                }

                .normal-input__suffix {
                    color: inherit;

                    i {
                        color: inherit;
                    }
                }
            }
        }
    }

    .common-header {
        //.transition-on;
        .left-part {
            .path-pair {
                &:hover {
                    color: unset !important;
                }
            }

            .logo-text-svg {
                .path-pair {
                    margin-left: 10px;
                }
            }

            .path-pair {
                margin: 19px 0 0 16px;
                font-size: 20px;

                span {
                    font-weight: normal !important;
                }

                .icon {
                    margin: 0 0 0 8.5px;
                    font-size: 12px;
                    /*color: #3c4455;*/
                    vertical-align: middle;
                }
            }
        }
    }
</style>

<style lang="less" scoped>
    @import '../../assets/less/widgets-var';

    @var-height: 74px;

    .common-header {
        margin: 0;
        top: 0;
        left: 0;
        z-index: 9997;
        right: 0;
        height: @var-height;
        box-sizing: border-box;
        background-color: #fff;
        border-bottom: 1px solid @otherBorderClr;
        min-width: 1200px;

        > .center {
            width: 100%;
            height: @var-height;
            position: relative;
            margin: 0 auto;

            > .left-part {
                > * {
                    cursor: pointer;
                }

                > .menu {
                    font-size: 16px;
                    width: 17px;
                    height: 25px;
                    margin: 26px 0 0 16px;

                    &.close {
                        margin: 23px 0 0 16px;

                        .lines {
                            height: 0;

                            &:before,
                            &:after {
                                transition: top 0.2s ease-in-out, -webkit-transform 0.2s 0.3s ease-in-out;
                                top: 0;
                                width: 17px;
                            }

                            &:before {
                                transform: rotate3d(0, 0, 1, 45deg);
                            }

                            &:after {
                                transform: rotate3d(0, 0, 1, -45deg);
                            }
                        }
                    }

                    .lines {
                        position: relative;

                        &,
                        &:before,
                        &:after {
                            background: @otherNormalTitleClr;
                            content: '';
                            display: inline-block;
                            width: 17px;
                            height: 2px;
                            transition: 0.2s;
                            -webkit-border-radius: 5px;
                            -webkit-background-clip: padding-box;
                            -moz-border-radius: 5px;
                            -moz-background-clip: padding;
                            border-radius: 5px;
                            background-clip: padding-box;
                        }

                        &:before {
                            position: absolute;
                            top: -5px;
                            left: 0;
                        }

                        &:after {
                            position: absolute;
                            top: 5px;
                            left: 0;
                        }
                    }
                }

                > .logo {
                    margin: 18px 0 0 50px;
                    display: block;
                    color: @primaryBg;
                    font-size: 35px;
                    cursor: pointer;
                    font-family: cmsicon;
                }

                > .logo-svg {
                    font-size: 43px;
                    margin: 14px 0 0 50px;
                }

                > .logo-text {
                    margin: 27px 0 0 16px;
                    font-size: 20px;
                    line-height: 20px;
                    color: @otherNormalTitleClr;
                    letter-spacing: 0;
                    cursor: pointer;
                }

                > .left-arrow-pos {
                    font-family: cmsicon;
                    margin: 31px 0 0 15px;
                    font-size: 12px;
                    color: @otherNormalTitleClr;
                }

                .left-split {
                    font-size: 16px;
                    margin: 26px 0 0 19px;
                }

                > .app-name {
                    line-height: 15px;
                    margin: 30px 0 0 17px;
                    font-size: 16px;
                }
            }

            > .right-part {
                width: auto;
                min-width: 1px;
                overflow-x: hidden;
                float: right;

                .left-split {
                    font-size: 16px;
                    margin: 26px 28px 0 0;
                }

                > .avatar {
                    cursor: pointer;
                    width: 26px;
                    height: 26px;
                    border-radius: 26px;
                    background-color: #fff;
                    margin: 24px 50px 0 0;
                }

                > .right-part-name-opt {
                    border: none;
                    color: @otherNormalTitleClr;
                    margin: 19px 0;

                    /deep/ .selected {
                        &:after {
                            color: inherit;
                        }
                    }
                }

                > .text-item {
                    width: auto;
                    min-width: 1px;
                    font-size: 15px;
                    color: #333;
                    position: relative;
                    cursor: pointer;

                    &:hover {
                    }

                    &:after {
                        content: '';
                        display: block;
                        position: absolute;
                        top: 10px;
                        right: 0;
                        height: 10px;
                        width: 2px;
                    }

                    &.website {
                        padding: 0;

                        .drop-frame {
                            margin: 0;
                            max-width: 400px !important;
                        }
                    }

                    > .dropdown-arrow {
                        width: 0;
                        height: 0;
                        position: absolute;
                        right: 12px;
                        top: 11px;
                        /*<!--border-top: 7px @grey700 solid;-->*/
                        border-right: 4px #fff solid;
                        border-left: 4px #fff solid;
                    }
                }

                > .icon-item {
                    color: @otherNormalTitleClr;
                    text-align: center;
                    cursor: pointer;
                    font-family: cmsicon;
                    font-size: 20px;
                    margin: 25.5px 26px 0 0;

                    &.message-icon {
                        margin-right: 18px;
                    }

                    &.message {
                        position: relative;

                        &:after {
                            content: '';
                            position: absolute;
                            display: block;
                            width: 8px;
                            height: 8px;
                            border-radius: 10px;
                            border: 1px solid @otherBorderClr;
                            left: 10px;
                            top: 8px;
                            background-color: @dangerBg;
                        }
                    }
                }
            }
        }
    }
</style>
